import { render, staticRenderFns } from "./FooterNewComp.vue?vue&type=template&id=b4e12298&scoped=true&"
import script from "./FooterNewComp.vue?vue&type=script&lang=js&"
export * from "./FooterNewComp.vue?vue&type=script&lang=js&"
import style0 from "./FooterNewComp.vue?vue&type=style&index=0&id=b4e12298&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b4e12298",
  null
  
)

export default component.exports